import { PREDICAMENT_STATE_YES } from "core/consts";
import { VerticalLayout } from "ds_legacy/materials/layouts";
import { margin, padding, sizing } from "ds_legacy/materials/metrics";
import {
  DatePickerWithLabel,
  LARGE_INPUT_WIDTH,
  Section,
  SectionRow,
  SMALL_INPUT_MIN_WIDTH,
  TextAreaWithLabel,
  YesNoRadioWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionTwo = () => {
  const translations = useTranslations();

  return (
    <Section title={translations.patientForms.drvMedicalForm.sectionTwo.title}>
      <SectionRow customPadding={padding(1, 0, 0)}>
        <TextAreaWithLabel
          elementName="complications"
          isBold
          label={
            translations.patientForms.drvMedicalForm.sectionTwo
              .descriptionComplications
          }
          marginOverride={margin(0)}
        />
      </SectionRow>
      <SectionRow>
        <TextAreaWithLabel
          elementName="current_therapy"
          isBold
          label={
            translations.patientForms.drvMedicalForm.sectionTwo
              .descriptionTherapies
          }
          marginOverride={margin(0)}
        />
      </SectionRow>
      <YesNoRadioWithLabel
        elementName="other_measures"
        label={
          translations.patientForms.drvMedicalForm.sectionTwo.otherMeasures
        }
        shouldStartWithNo
        sideMutation={(_value, mutate) => {
          mutate(null, "further_therapeutic_diagnostic_measures_description");
          mutate(null, "further_therapeutic_diagnostic_measures_from");
          mutate(null, "further_therapeutic_diagnostic_measures_to");
          mutate(null, "further_therapeutic_diagnostic_measures_finished_on");
        }}
        subForms={{
          [PREDICAMENT_STATE_YES]: (
            <VerticalLayout
              gap={sizing(1)}
              padding={padding(0, 0, 1)}
              width="100%"
            >
              <TextAreaWithLabel
                elementName="further_therapeutic_diagnostic_measures_description"
                label={
                  translations.patientForms.drvMedicalForm.sectionTwo
                    .descriptionMeasures
                }
                marginOverride={margin(0)}
                withFlatModel
              />
              <SectionRow>
                <DatePickerWithLabel
                  elementName="further_therapeutic_diagnostic_measures_from"
                  inputSx={{
                    minWidth: SMALL_INPUT_MIN_WIDTH,
                    width: "100%",
                  }}
                  isBold
                  label={
                    translations.patientForms.drvMedicalForm.sectionTwo.fromDate
                  }
                  withFlatModel
                  wrapperSx={{ width: LARGE_INPUT_WIDTH }}
                />
                <DatePickerWithLabel
                  elementName="further_therapeutic_diagnostic_measures_to"
                  inputSx={{
                    minWidth: SMALL_INPUT_MIN_WIDTH,
                    width: "100%",
                  }}
                  isBold
                  label={
                    translations.patientForms.drvMedicalForm.sectionTwo
                      .untilDate
                  }
                  withFlatModel
                  wrapperSx={{ width: LARGE_INPUT_WIDTH }}
                />
                <DatePickerWithLabel
                  elementName="further_therapeutic_diagnostic_measures_finished_on"
                  inputSx={{
                    minWidth: SMALL_INPUT_MIN_WIDTH,
                    width: "100%",
                  }}
                  isBold
                  label={
                    translations.patientForms.drvMedicalForm.sectionTwo
                      .endsOnDate
                  }
                  withFlatModel
                  wrapperSx={{ width: LARGE_INPUT_WIDTH }}
                />
              </SectionRow>
            </VerticalLayout>
          ),
        }}
      />
    </Section>
  );
};
